import { Injectable } from '@angular/core';

import { IEntityConfig, ENTITY_TYPES, BackendApiType } from '@app/shared/types';

import { BaseService } from '../base';

const entityType: ENTITY_TYPES = ENTITY_TYPES.VENDOR;
const config: IEntityConfig = {
  backendApiType: BackendApiType.DM,
  ENTITY_TYPE: entityType,
  isMasterListAvailable: true,
  apiEndpoint: entityType,
  uiRoute: entityType,
  customEntityRoute: {
    list: 'master',
  },
  buttons: {},
};

/**
 * Inventory Item service that extends BaseService to use
 * basic CRUD request operations
 */
@Injectable()
export class VendorService extends BaseService {
  public static config: IEntityConfig = config;
  public static ENTITY_TYPE: string = config.ENTITY_TYPE;
}
